<template>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generarPagoAbono)">
            <b-row>
                <b-col v-if="!bloquear" md="12" class="mb-3">
                    <h4 class="text-center f-bariol text-bold">
                        Formulario de abono
                    </h4>
                </b-col>

                <b-col v-if="!bloquear" sm="6">
                    <ValidationProvider rules="required" v-slot="validationContext">
                        <b-form-group label-align="left" label="RUT de comercio:">
                            <b-input-group>
                                <b-form-input v-model="formulario.rut" :state="!rutValido
                                    ? false
                                    : getValidationState(
                                        validationContext
                                    )
                                    " placeholder="Ej: 12345678-9" class="input-movired" size="lg">
                                </b-form-input>
                            </b-input-group>
                            <b-form-invalid-feedback v-if="!rutValido" class="mt-2 d-block">
                                El rut ingresado no es válido
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback :class="validationContext.errors[0] ? 'd-block' : ''
                                ">
                                {{
                                    validationContext.errors[0]
                                    ? validationContext.errors[0].replace(
                                        "{field}",
                                        ""
                                    )
                                    : validationContext.errors[0]
                                }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col v-if="!bloquear" sm="6">
                    <ValidationProvider rules="required|numeric|min_value:0" v-slot="validationContext">
                        <b-form-group label-align="left" label="Monto de abono: ">
                            <b-input-group>
                                <b-form-select v-model="formulario.monto" :options="montosAbono" :state="getValidationState(validationContext)
                                    " class="input-movired" size="lg"></b-form-select>
                            </b-input-group>
                            <b-form-invalid-feedback class="mt-2" :class="validationContext.errors[0] ? 'd-block' : ''
                                ">
                                {{
                                    validationContext.errors[0]
                                    ? validationContext.errors[0].replace(
                                        "{field}",
                                        ""
                                    )
                                    : validationContext.errors[0]
                                }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col v-if="bloquear" md="12">
                    <spinner></spinner>
                </b-col>

                <b-col v-if="!bloquear" md="6" class="text-center mb-3">
                    <b-button size="lg" variant="dark" pill block @click="volverAtras">
                        Volver
                    </b-button>
                </b-col>
                <b-col v-if="!bloquear" md="6" class="text-center">
                    <b-button type="submit" size="lg" variant="danger" pill block class="button-movired-color">
                        Continuar
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </ValidationObserver>
</template>

<script>
const Swal = require("sweetalert2");

import {
    BRow,
    BCol,
    BButton,
    BForm,
    BInputGroup,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
    BImg,
    BFormSelect
} from "bootstrap-vue";
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize,
} from "vee-validate";
import es from "vee-validate/dist/locale/es";
import {
    required,
    min,
    numeric,
    email,
    min_value,
} from "vee-validate/dist/rules";
import { mapActions, mapState } from "vuex";
import mixinComercio from "../../../plugins/mixinComercio";

extend("required", required);
extend("email", email);
extend("numeric", numeric);
extend("min", min);
extend("min_value", min_value);

localize("es", es);

require("jquery.rut");

export default {
    namespaced: true,
    mixins: [mixinComercio],
    components: {
        BRow,
        BCol,
        BButton,
        BForm,
        BInputGroup,
        ValidationObserver,
        ValidationProvider,
        BFormInput,
        BFormGroup,
        BFormInvalidFeedback,
        BImg,
        BFormSelect,
        Spinner: () =>
            import(
                /* webpackChunkName: "spinner", webpackPrefetch: true */ "../../../components/spinner/Spinner.vue"
            ),
    },
    data() {
        return {
            formulario: {
                rut: null,
                monto: null,
            },
            rutValido: true,
            identificador_pro: 2,
            bloquear: false,
            montosAbono: [
                {
                    value: null,
                    text: "Selecciona una opción"
                }
            ],
        };
    },
    watch: {
        "formulario.rut": function (val) {
            if (val.length > 3) {
                this.rutValido = $.validateRut(val);
                this.formulario.rut = $.formatRut(val, false);
                this.formulario.rut = this.formulario.rut.toUpperCase();
            }
        },
    },
    computed: {
        ...mapState(["urlBaseS3", "configuracionCliente"]),
        ...mapState("comercio", ["configuracionComercio"])
    },
    mounted() {
        this.obtenerConfiguracion('/comercios/abono')
    },
    methods: {
        ...mapActions("comercio", ["actualizarTrxComercio", "resetearTrxComercio", "actualizarConfiguracionComercio"]),
        ...mapActions(["actualizarConfiguracionCliente"]),
        async obtenerConfiguracion() {
            try {
                const resComercioConfiguracion = await axios.get("/api/comercio/configuracion");
                const resClienteConfiguracion = await axios.post("/api/configuracion/cliente", {
                    navigation_url: '/comercios'
                });

                if (resComercioConfiguracion.status === 200) {
                    this.actualizarConfiguracionComercio(resComercioConfiguracion.data);
                }

                if (resClienteConfiguracion.status === 200) {
                    this.actualizarConfiguracionCliente(resClienteConfiguracion.data);
                }

                if (!this.configuracionComercio || !this.configuracionComercio.includes(1)) {
                    this.$router.push({ name: "comercio" });
                }

                this.obtenerMontos()

                if (Object.keys(this.$route.params).length > 0) {
                    this.bloquear = true
                    this.formulario.rut = this.$route.params.rut
                    this.formulario.monto = this.$route.params.monto

                    if (this.$route.params.codigo) {
                        this.formulario.codigo = this.$route.params.codigo
                    }

                    this.generarPagoAbono()
                }

            } catch (error) {
                console.error(error);
            }
        },
        async obtenerMontos() {
            let resComercioMontos = await axios.get("/api/comercio/montos");

            if (resComercioMontos.status == 200) {
                resComercioMontos.data.forEach(item => this.montosAbono.push({
                    value: item.monto,
                    text: new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(item.monto),
                }));
            }
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        async generarPagoAbono() {
            this.bloquear = true;

            if (!this.formulario.rut || !this.rutValido) {
                Swal.fire({
                    title: "Notificación",
                    text: "El RUT ingresado no es válido.",
                    icon: "error",
                    showCancelButton: false,
                    cancelButtonText: "Cerrar notificación",
                    customClass: {
                        confirmButton:
                            "btn boton-pagar btn-pill btn-md button-movired-color btn-block",
                    },
                    buttonsStyling: false,
                });

                this.bloquear = false;
                return false;
            }


            let clienteId = this.configuracionCliente.cliente;
            let productoCliente = this.buscarProducto(
                this.configuracionCliente.productos,
                this.identificador_pro
            );

            let resToken = await axios.post("/api/generar/token", {
                cliente_id: clienteId,
            });

            if (resToken.data.token) {
                let resTrxComercio = await axios.post(
                    "/api/comercio/generar/trx",
                    {
                        rut_comercio: this.formulario.rut,
                        abono: this.formulario.monto,
                        codigo: this.formulario.codigo ? this.formulario.codigo : null,
                        session_cliente_id: clienteId,
                        producto_cliente: productoCliente.identificador,
                        enlace: 1,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${resToken.data.token}`,
                        },
                    }
                );

                if (resTrxComercio.data.estado == true && resTrxComercio.data.habilitado == true) {
                    this.actualizarTrxComercio({
                        trxComercio: resTrxComercio.data.trx,
                    });

                    this.bloquear = false;
                    this.$router.push({ name: "comercioConfirmacion" });
                }

                if (resTrxComercio.data.estado == true && resTrxComercio.data.habilitado == false) {
                    Swal.fire({
                        title: "Notificación",
                        text: "El comercio ingresado se encuentra deshabilitado, por favor contacte a soporte.",
                        icon: "error",
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: "Cerrar notificación",
                        customClass: {
                            cancelButton: "btn button-movired-color btn-block btn-md mx-1",
                        },
                        buttonsStyling: false,
                    }).then((result) => {
                        this.bloquear = false;
                    });
                }

                if (
                    resTrxComercio.data.estado == false &&
                    resTrxComercio.data.comercio == false
                ) {
                    /* Swal.fire({
                        title: "Notificación",
                        text: "No encontramos este comercio en nuestros registros, te invitamos a registrarte.",
                        icon: "error",
                        showCancelButton: true,
                        cancelButtonText: "Cerrar notificación",
                        confirmButtonText: "Registrar comercio",
                        customClass: {
                            confirmButton:
                                "btn boton-pagar btn-md button-movired-color mx-1",
                            cancelButton: "btn btn-dark btn-md mx-1",
                        },
                        buttonsStyling: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.bloquear = false;
                            this.$router.push({ name: "comercioRegistro" });
                        } else {
                            this.bloquear = false;
                        }
                    }); */

                    Swal.fire({
                        title: "Notificación",
                        html: '<center>No encontramos este comercio en nuestros registros.',
                        icon: "error",
                        showCancelButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                        didOpen: () => {
                            Swal.showLoading()
                            const b = Swal.getHtmlContainer().querySelector('b')
                            const timerInterval = setInterval(() => {
                                b.textContent = Math.round(Swal.getTimerLeft() / 1000)
                            }, 100)
                        },
                    }).then((result) => {
                        if (result.isConfirmed || result.dismiss) {
                            this.bloquear = false;
                            //this.$router.push({ name: "comercioRegistro" });
                        } else {
                            this.bloquear = false;
                        }
                    });
                }
            } else {
                this.bloquear = false;
            }

            /* if (resVerificacionPago.data.t_estado == false) {
                this.tokenInvalido();
                return false;
            } */
        },
        volverAtras() {
            this.$router.push({ name: "comercioSeleccion" });
        },
    },
};
</script>
